import { render, staticRenderFns } from "./m-newsItem.vue?vue&type=template&id=ee3377b2&scoped=true&"
import script from "./m-newsItem.vue?vue&type=script&lang=ts&"
export * from "./m-newsItem.vue?vue&type=script&lang=ts&"
import style0 from "./m-newsItem.vue?vue&type=style&index=0&id=ee3377b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3377b2",
  null
  
)

export default component.exports